import { Skeleton } from "@mui/material";
import { range } from "ramda";

export default function TableSkeleton({ numberOfLines = 10 }: { numberOfLines?: number }) {
  const lines = range(0, numberOfLines).map((line) => <Skeleton key={line} />);

  return <>{lines}</>;
}
